module.exports = __webpack_public_path__ + "img/ched.732385cc.jpg";